import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-565581e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "width", "height"]

import { computed, nextTick, ref, watch } from 'vue'

import { assertNotNull } from '@/helpers/typing'
import { getImage, QuestionnaireView } from '@/models/onboarding'
import { OptionsPage, QuestionnaireFormOption } from '@/models/onboarding.types'
import { PublicInterface } from '@/models/interfaces'

import Layout from '../Layout.vue'
import OptionRadio from '../OptionRadio.vue'
import OptionText from '../OptionText.vue'
import OptionCheckbox from '../OptionCheckbox.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Options',
  props: {
    view: null
  },
  setup(__props: any) {

const props = __props as {
  view: PublicInterface<QuestionnaireView>
};



const page = computed(() => {
  return props.view.currentPage as OptionsPage
})

const selectedOptions = ref<string[]>([])

watch(selectedOptions, (newValue) => {
  if (page.value.multipleOptions) {
    props.view.setCurrentChoice(newValue)
  } else {
    // `selectedOptions` is an array to make it easier
    // to handle multiple-option pages, but if this
    // is not a multi-option page, then `selectedOptions`
    // should only have one item.
    props.view.setCurrentChoice(newValue[0])
  }
})

const options = computed(() => {
  // Remove the `skip` option. We handle it differently than the other options.
  return page.value.options.filter((option) => option.type !== 'skip')
})

const skipOption = computed(() => {
  return page.value.options.find(
    (option) => typeof option !== 'string' && option.type === 'skip',
  ) as QuestionnaireFormOption | undefined
})

const image = computed(() => {
  if (!page.value.image) {
    return
  }

  return getImage(page.value.image.src)
})

/**
 * Set `selectedOptions` to the value of the `skipOption`,
 * and navigate to the next page.
 */
async function skip(): Promise<void> {
  selectedOptions.value = [assertNotNull(skipOption.value?.label)]
  // Wait for `watch`.
  await nextTick()

  await props.view.nextPage()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    id: _unref(page).id,
    class: "onboarding-options",
    title: _unref(page).title,
    subtitle: _unref(page).subtitle,
    scrollDefaultSlot: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["onboarding-options__options", {
        'onboarding-options__options--wrap': _unref(page).wrapInputs,
      }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (option) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (_unref(page).multipleOptions)
              ? (_openBlock(), _createBlock(OptionCheckbox, {
                  key: `a-${option.label}`,
                  modelValue: selectedOptions.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOptions).value = $event)),
                  class: _normalizeClass(["onboarding-options__option", { 'onboarding-options__option--center': _unref(page).centerText }]),
                  option: option,
                  maxOptions: _unref(page).maxOptions
                }, null, 8, ["modelValue", "class", "option", "maxOptions"]))
              : (option.type === 'text-input')
                ? (_openBlock(), _createBlock(OptionText, {
                    key: `b-${option.label}`,
                    modelValue: selectedOptions.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOptions).value = $event)),
                    class: _normalizeClass(["onboarding-options__option", { 'onboarding-options__option--center': _unref(page).centerText }]),
                    option: option
                  }, null, 8, ["modelValue", "class", "option"]))
                : (_openBlock(), _createBlock(OptionRadio, {
                    key: `c-${option.label}`,
                    modelValue: selectedOptions.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedOptions).value = $event)),
                    class: _normalizeClass(["onboarding-options__option", { 'onboarding-options__option--center': _unref(page).centerText }]),
                    option: option
                  }, null, 8, ["modelValue", "class", "option"]))
          ], 64))
        }), 256))
      ], 2),
      (_unref(skipOption))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "onboarding-options__option-skip",
            onClick: skip
          }, _toDisplayString(_unref(skipOption).label), 1))
        : _createCommentVNode("", true),
      (_unref(page).image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "onboarding-options__image",
            src: _unref(image),
            width: _unref(page).image.width,
            height: _unref(page).image.height,
            alt: ""
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["id", "title", "subtitle"]))
}
}

})